import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const AREAS = [
  { to: "/instructional-design", title: "Instructional Design", tag: "Courses, ERP training & LXD", img: "/assets/tile-instructional.jpg" },
  { to: "/photography-videography", title: "Photography & Videography", tag: "Events, portraits & film", img: "/assets/photography/photo-03.jpg" },
  { to: "/web-graphic-design", title: "Web & Graphic Design", tag: "Sites, brands & flyers", img: "/assets/sites/cares.jpg" },
  { to: "/interior-design", title: "Interior Design", tag: "Spaces & real estate", img: "/assets/interior/room-01.jpg" },
];

export const AreaCards = () => (
  <section data-testid="area-cards" className="mx-auto max-w-[1500px] px-6 md:px-12 py-20 md:py-28">
    <Reveal className="max-w-3xl">
      <p className="overline text-terracotta">Explore</p>
      <h2 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight leading-[0.95] text-ink">
        Pick a lane.
      </h2>
      <p className="mt-4 text-base text-stone max-w-xl">
        Each area of my work lives on its own page. Tap any card to dive in.
      </p>
    </Reveal>

    <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
      {AREAS.map((a, i) => (
        <Reveal key={a.to} delay={i * 0.08}>
          <Link
            to={a.to}
            data-testid={`area-card-${i}`}
            className="group block overflow-hidden rounded-2xl border border-line bg-sand hover:-translate-y-1.5 hover:border-ink/30 transition-[transform,border-color] duration-500"
          >
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={a.img}
                alt={a.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/10 to-ink/0" />
              <span className="absolute right-4 top-4 grid place-items-center w-10 h-10 rounded-full bg-paper/90 text-ink group-hover:bg-terracotta group-hover:text-paper transition-colors duration-300">
                <ArrowUpRight size={18} />
              </span>
              <div className="absolute left-5 bottom-5 right-5">
                <p className="text-[0.65rem] uppercase tracking-[0.18em] text-paper/70">{a.tag}</p>
                <p className="mt-1 font-serif text-2xl text-paper tracking-tight leading-tight">
                  {a.title}
                </p>
              </div>
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
);
